<template>
  <!-- Crete Gift Certificate dialog -->
  <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
    <v-card class="pa-4">
      <v-card-title class="mb-2">
        <h2 class="title">
          Create New Gift Certificate
          <span v-if="!no_data.includes(clientName)">{{
            `For ${clientName}`
          }}</span>
        </h2>
      </v-card-title>
      <div v-if="createForClient && loadingClients" class="my-4 px-6">
        <v-progress-linear
          indeterminate
          style="height: 2px;"
        ></v-progress-linear>
      </div>
      <template v-else>
        <v-card-text>
          <v-flex class="px-2">
            <v-flex v-if="!createForClient">
              <v-autocomplete
                :items="clients"
                v-model="preparedData.client_id"
                label="Client"
                item-text="full_name"
                item-value="id"
                placeholder="Please Select"
                :required="true"
                :loading="loadingClients"
                :error-messages="errors($v.preparedData.client_id) || server_errors.client_id"
                @focus="resetServerValidation"
                @blur="$v.preparedData.client_id.$touch()"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-text-field
                name="purchaser_name"
                label="Purchaser Name"
                v-model="preparedData.purchaser_name"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.purchaser_name) || server_errors.purchaser_name"
                @focus="resetServerValidation"
                @blur="$v.preparedData.purchaser_name.$touch()"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="purchaser_email"
                label="Purchaser Email"
                v-model="preparedData.purchaser_email"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.purchaser_email) || server_errors.purchaser_email"
                @focus="resetServerValidation"
                @blur="$v.preparedData.purchaser_email.$touch()"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="purchaser_phone"
                label="Purchaser Phone"
                v-model="preparedData.purchaser_phone"
                placeholder="Please Enter"
                v-mask="'(###) ### - ####'"
                :error-messages="errors($v.preparedData.purchaser_phone) || server_errors.purchaser_phone"
                @focus="resetServerValidation"
                @blur="$v.preparedData.purchaser_phone.$touch()"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="amount"
                label="Amount"
                v-model="preparedData.amount"
                prefix="$"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.amount) || server_errors.amount"
                @focus="resetServerValidation"
                @blur="$v.preparedData.amount.$touch()"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-menu
                ref="menu1"
                label="Expires"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="preparedData.expires"
                    label="Expires"
                    placeholder="Please Select"
                    prepend-icon="event"
                    readonly
                    :error-messages="errors($v.preparedData.expires) || server_errors.expires"
                    @focus="resetServerValidation"
                    @change="$v.preparedData.expires.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="preparedData.expires"
                  no-title
                  @input="menu1 = false"
                  :min="minDate"
                  class="dialog-text-color"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                ref="menu2"
                label="Bought"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="preparedData.bought"
                    label="Bought"
                    placeholder="Please Select"
                    prepend-icon="event"
                    readonly
                    :error-messages="errors($v.preparedData.bought) || server_errors.bought"
                    @focus="resetServerValidation"
                    @change="$v.preparedData.bought.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="preparedData.bought"
                  no-title
                  @input="menu2 = false"
                  class="dialog-text-color"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-text-field
                name="reference_number"
                label="Reference Number"
                v-model="preparedData.reference_number"
                placeholder="Please Enter"
                :error-messages="reference_number_error_message || errors($v.preparedData.reference_number) || server_errors.reference_number"
                :loading="reference_number_loading"
                :success-messages="reference_number_success_message"
                @focus="resetServerValidation"
                @blur="$v.preparedData.reference_number.$touch()"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex>
              <v-text-field
                name="recipient_name"
                label="Recipient Name"
                v-model="preparedData.recipient_name"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.recipient_name) || server_errors.recipient_name"
                @focus="resetServerValidation"
                @blur="$v.preparedData.recipient_name.$touch()"
              ></v-text-field>
            </v-flex> -->
            <!-- <v-flex>
              <v-text-field
                name="recipient_email"
                label="Recipient Email"
                v-model="preparedData.recipient_email"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.recipient_email) || server_errors.recipient_email"
                @focus="resetServerValidation"
                @blur="$v.preparedData.recipient_email.$touch()"
              ></v-text-field>
            </v-flex> -->
            <v-flex>
              <v-text-field
                name="special_note"
                label="Special Note"
                v-model="preparedData.special_note"
                placeholder="Please Enter"
                :error-messages="errors($v.preparedData.special_note) || server_errors.special_note"
                @focus="resetServerValidation"
                @blur="$v.preparedData.special_note.$touch()"
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-alert
            class="pa-2 mt-4"
            :value="$v.preparedData.$error || !no_data.includes(reference_number_error_message)"
            outlined
            color="error"
            icon="priority_high"
            transition="scale-transition"
          >
            <span class="caption">Please fill out all required fields</span>
          </v-alert>
          <v-alert
            class="pa-2 mt-4"
            :value="!serverValidation"
            outlined
            color="error"
            icon="priority_high"
            transition="scale-transition"
          >
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="saveLoading"
            :disabled="saveLoading"
            @click="addNewCertificate"
            >Save</v-btn
          >
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service";
import { validationMixin } from "vuelidate";
import { required, decimal, helpers, email } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";
import { mapActions } from 'vuex'
import { mask } from 'vue-the-mask'

let validations = {}

export default {
  name: "CreateGiftCertificate",
  mixins: [validationMixin],
  validations() {
    validations = {
      preparedData: {
        client_id: {},
        purchaser_name: { required },
        purchaser_email: { required, email },
        purchaser_phone: { phone: v => !helpers.req(v) || /^\d{10}$/.test(v.replace(/[()-\s]/g, "")) },
        amount: {
          required,
          decimal,
          positive: v => !helpers.req(v) || v > 0,
          currency: v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v) 
        },
        expires: {},
        bought: { required },
        reference_number: { required },
        // recipient_name: { required },
        // recipient_email: { required, email },
        special_note: {},
      }
    }
    this.errors = getValMessage(valMessages)(validations);
    return validations;
  },
  directives: {mask},
  data: () => ({
    no_data: [null, "", undefined, "null"],
    clients: [],
    loadingClients: false,
    menu1: false,
    menu2: false,
    showDialog: false,
    createForClient: false,
    clientName: null,
    preparedData: {},
    saveLoading: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {},
    reference_number_error_message: "",
    reference_number_success_message: "",
    reference_number_loading: false,
    unsubscribe: null
  }),
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'CreateGiftCertificate') {
          this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    getClients() {
      this.loadingClients = true
      ApiService.get("/client/list", { statuses: ['active']})
        .then(response => {
          let data = response.data;
          this.clients = data.clients;
          if (
            this.createForClient &&
            !this.no_data.includes(this.preparedData) &&
            !this.no_data.includes(this.preparedData.client_id) &&
            this.clients.some(
              i => Number(i.id) === Number(this.preparedData.client_id) &&
              !this.no_data.includes(i.full_name)
            )
          ) {
            this.clientName = this.clients.find(
              i => Number(i.id) === Number(this.preparedData.client_id)
            ).full_name;
          }
          this.loadingClients = false
        })
        .catch(error => {
          console.log(error);
          this.loadingClients = false
        });
    },
    openModal(client_id = null) {
      this.createForClient = false
      this.clientName = null
      this.getClients()
      this.$v.$reset()
      this.resetServerValidation()
      this.preparedData = {}
      if (client_id !== null) {
        this.preparedData.client_id = Number(client_id)
        this.createForClient = true
      }
      this.showDialog = true
    },
    addNewCertificate() {
      this.$v.$touch();
      this.resetServerValidation();
      if (!this.$v.$invalid && this.no_data.includes(this.reference_number_error_message)) {
        this.saveLoading = true;
        let body = { ...this.preparedData };
        if(!this.no_data.includes(body.purchaser_phone)) {
          body.purchaser_phone = this.phoneWithoutMask(body.purchaser_phone)
        }
        ApiService.put("/gift_cards/create", body)
          .then(response => {
            this.saveLoading = false;
            this.vEmit({
              name: "notification", 
              data: {
                status: "success",
                text: "New certificate has been successfully added."
              }
            });
            this.closeModal()
            this.vEmit({ name: 'getClientBalance' })
            this.vEmit({ name: "getClientInvoices" })
            this.$emit("done");
          })
          .catch(({ response }) => {
            this.saveLoading = false
            this.serverValidation = false
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(response.data.error)
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors
            }
          });
      }
    },
    closeModal() {
      this.showDialog = false;
      this.reference_number_error_message = "";
      this.reference_number_success_message = "";
    },
    checkReferenceNumber(reference_number) {
      if (reference_number) {
        this.reference_number_error_message = "";
        this.reference_number_success_message = "";
        this.reference_number_loading = true;
        ApiService.put("/gift_cards/find", { reference_number })
          .then(response => {
            this.reference_number_loading = false;
            if (response.data.gift_card !== null) {
              this.reference_number_error_message = "Reference number is already in use";
              this.reference_number_success_message = "";
            } else {
              this.reference_number_error_message = "";
              this.reference_number_success_message = "Reference number is valid";
            }
          })
          .catch(error => {
            this.reference_number_loading = false;
            this.reference_number_error_message = "Oops something went wrong...";
            this.reference_number_success_message = "";
          });
      } else {
        this.reference_number_error_message = "";
        this.reference_number_success_message = "";
      }
    },
    phoneWithoutMask (phone) {
      if(phone && typeof phone === 'string') {
          return phone.replace(/[()-\s]/g, "")
      } else {
          return phone
      }
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = "Oops something went wrong..."
      this.server_errors = {}
    },
    errors: getValMessage(valMessages)(validations)
  },
  computed: {
    minDate: function() {
      return moment().format("YYYY[-]MM[-]DD");
    }
  },
  watch: {
    'preparedData.reference_number': _.debounce(function(val) {
      this.checkReferenceNumber(val);
    }, 1000)
  },
};
</script>
